import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Nav,
  Row,
  Form,
  Pagination,
  Card,
  Table,
  Button,
  InputGroup,
  Modal,
  FormCheck,
} from "@themesberg/react-bootstrap";

import { useParams } from "react-router-dom";
import { dropdownItems } from "../../data/tables";
import axios from "axios";
import swal from "sweetalert";
import {
  getVendors,
  createProjectAnnoucementEmail,
  getProjectAnnoucement,
} from "../../app/api";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import ButtonLoader from "../../components/ButtonLoader";
export default () => {
  const { id } = useParams();
  const history = useHistory();
  const [show, setShow] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState([]);
  const [selectedVendorEmails, setSelectedVendorEmails] = useState([]);
  const [selectedVendorIds, setSelectedVendorIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [search, setSearch] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => {
    // console.log("Selected vendor emails:", selectedVendorEmails);
    setShow(true);
  };
  const handleCheckboxChange = (vendorId, vendorEmail) => {
    console.log(vendorId);
    if (selectedVendorIds.includes(vendorId)) {
      setSelectedVendorIds(selectedVendorIds.filter((id) => id !== vendorId));
      setSelectedVendorEmails(
        selectedVendorEmails.filter((email) => email !== vendorEmail)
      );
    } else {
      setSelectedVendorIds([...selectedVendorIds, vendorId]);
      setSelectedVendorEmails([...selectedVendorEmails, vendorEmail]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedVendorIds([]);
      setSelectedVendorEmails([]);
    } else {
      const allVendorIds = vendors.map((vendor) => vendor.id);
      const allVendorEmails = vendors.map((vendor) => vendor.email);
      setSelectedVendorIds(allVendorIds);
      setSelectedVendorEmails(allVendorEmails);
    }
    setSelectAll(!selectAll);
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    // console.log("Selected vendor emails:", selectedVendorEmails);
    try {
      const token = localStorage.getItem("token");

      const ProjectAnnoucement = {
        announcement_id: id,
        vendor_ids: selectedVendorIds,
      };
      let response;

      response = await axios.post(
        createProjectAnnoucementEmail(),
        ProjectAnnoucement,
        {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        }
      );
      swal({
        text: response.data.message,
        icon: "success",
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text:  error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
      handleClose();
      setSelectedVendorIds([]);
    }
  };

  const [position, setPosition] = useState([]);

  const handleAssetSelect = (e) => {
    const selectedId = e.target.value;
    const selectedPositon = dropdownItems.find(
      (positions) => positions.name === selectedId
    );

    // Avoid duplicates
    if (
      selectedPositon &&
      !position.some((positions) => positions.name === selectedId)
    ) {
      setPosition([...position, selectedPositon]);

      // console.log(position);
    }
  };

  const removePosition = (positionToRemove) => {
    setPosition(
      position.filter((positions) => positions.name !== positionToRemove.name)
    );
  };
  const fetchVendors = async (currentPage) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const positionQuery = position.map((item) => item.value).join(",");
      const response = await axios.get(getVendors(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage,
          position: positionQuery,
          search,
        },
      });
      // console.log(response.data);

      setVendors(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors(page);
  }, [page, position, search]);
  const handleBackClick = () => {
    history.push(Routes.ProjectAnnoucement.path);
  };

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const fetchSingleProject = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getProjectAnnoucement(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);

      setTitle(response.data?.announcement?.title);
      setDescription(response.data?.announcement?.description);
    } catch (error) {
      // console.error("Error fetching Project:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleProject();
  }, [id]);
  return (
    <>
      <div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-start mb-2">
          <div className="d-block  mb-md-0">
            <h4 className="mb-0">Vendors</h4>
            {/* <p className="mb-0">
                Select the vendors you want to send the project announcements
              </p> */}
            <p className="mb-0">Title: {title}</p>
            <p className="mb-0 d-flex ">
              Description: &nbsp;
              <span dangerouslySetInnerHTML={{ __html: description }} />
            </p>
          </div>
          <Button variant="primary" onClick={handleBackClick} className=" me-2">
            <span>Back</span>
          </Button>
        </div>

        <Modal
          style={{ top: "10%" }}
          show={show}
          onHide={handleClose}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>Vendor Email Sending</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="email-tags-container">
              {selectedVendorEmails.map((email, index) => (
                <span key={index} className="email-tag">
                  {email}
                </span>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              Close
            </Button>
            {loadingBtn ? (
              <div className="d-flex justify-content-start">
                <ButtonLoader />
              </div>
            ) : (
              <Button variant="primary" onClick={handleSendEmail}>
                Send Now
              </Button>
            )}
          </Modal.Footer>
        </Modal>
        <Row className="justify-content-between align-items-center mb-4">
          <Col xs={12} md={3} lg={3} xl={3}>
            {/* <Form.Label>Select Assets</Form.Label>     */}
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                placeholder="Search"
              />
            </InputGroup>
          </Col>

          <Col xs={12} md={4} lg={6} xl={6}>
            <Form.Group>
              <div
                style={{
                  position: "relative",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  // padding: "5px",
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  background: "white",
                }}
              >
                {position.map((positions) => (
                  <span
                    key={positions.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "2px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "3px",
                      padding: "5px",
                    }}
                  >
                    {positions.name}
                    <button
                      onClick={() => removePosition(positions)}
                      style={{
                        marginLeft: "5px",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#ce1126",
                      }}
                    >
                      x
                    </button>
                  </span>
                ))}

                <Form.Select
                  defaultValue="0"
                  onChange={handleAssetSelect}
                  style={{
                    border: "none",
                    outline: "none",
                    flex: "1",
                    minWidth: "150px",
                    boxShadow: "none",
                  }}
                >
                  <option value="">Select position</option>
                  {dropdownItems.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>
          <Col xs={4} md={3} lg={3} xl={3}>
            <Button variant="primary" className=" me-2" onClick={handleShow}>
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              <span>Send</span>
            </Button>
          </Col>
        </Row>
        {/* </div> */}
        <Card
          border="light"
          className="table-wrapper table-responsive shadow-sm"
        >
          <Card.Body className="p-0">
            <Table hover className="user-table align-items-center ">
              {loading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </div>
              ) : (
                <>
                  <thead>
                    <tr>
                      <th className="border-bottom">
                        {" "}
                        <Form.Check type="checkbox">
                          <FormCheck.Input
                            id="defaultCheck5"
                            className="me-2"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                          <FormCheck.Label
                            htmlFor="defaultCheck5"
                            className="mb-0"
                            style={{color:"white"}}
                          >
                            {selectAll ? "Un Select All" : "Select All"}
                          </FormCheck.Label>
                        </Form.Check>
                      </th>
                      <th className="border-bottom">Vendor Name</th>
                      <th className="border-bottom">Vendor Email</th>
                      <th className="border-bottom">Status</th>
                      <th className="border-bottom">Position</th>
                    </tr>
                  </thead>

                  <tbody>
                    {vendors.map((vendor, index) => (
                      <>
                        <tr key={index}>
                          <td className="fw-normal">
                            <Form.Check type="checkbox">
                              <FormCheck.Input
                                id="defaultCheck5"
                                className="me-2"
                                checked={selectedVendorIds.includes(vendor.id)}
                                onChange={() =>
                                  handleCheckboxChange(vendor.id, vendor.email)
                                }
                              />
                            </Form.Check>
                          </td>
                          <td>
                            <span className="fw-normal">
                              {vendor?.company_name}
                            </span>
                          </td>
                          <td>
                            <span className="fw-normal">{vendor?.email}</span>
                          </td>
                          <td>
                            <span className="fw-normal">{vendor?.status}</span>
                          </td>
                          <td>
                            <span className="fw-normal">
                              {vendor?.position}
                            </span>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </>
              )}
            </Table>
            <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">
              <Nav className="justify-content-center mb-4">
                <Pagination className="mb-2 mb-lg-0">
                  <Pagination.Prev
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  />
                  {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === page}
                      onClick={() => setPage(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalPages))
                    }
                  />
                </Pagination>
              </Nav>
            </Card.Footer>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
